import { custom } from '@carboledger/ui';
import { getTranslation } from '@/lib/utils/i18n';
import { referenceIdNumberRule, positiveNumberRule } from '@/lib/validation';

// Format rules for <OrderForm>. `required` is declared on each <Field>, so these cover format only.
export const orderValidation = {
  idNumber: referenceIdNumberRule,
  contractedQuantity: positiveNumberRule,
  tolerance: positiveNumberRule,
  ghgEmissions: positiveNumberRule,
  ghgEmissionSavings: positiveNumberRule,
};

/**
 * Props:
 *   shippedMin    the shipped total, already in the unit currently selected
 *   allocatedMin  the allocated total, already in the unit currently selected
 *   unit          that unit's symbol, for the messages
 */
export const buildOrderQuantityRules = ({ shippedMin, allocatedMin, unit }) => {
  const rules = [...orderValidation.contractedQuantity];
  if (shippedMin) {
    rules.push(
      custom(
        (value) => Number(value) >= shippedMin,
        getTranslation('ORDERS_QUANTITY_BELOW_SHIPPED', { quantity: shippedMin, unit: unit ?? '' }),
      ),
    );
  }
  if (allocatedMin) {
    rules.push(
      custom(
        (value) => Number(value) >= allocatedMin,
        getTranslation('ORDERS_QUANTITY_BELOW_ALLOCATED', {
          quantity: allocatedMin,
          unit: unit ?? '',
        }),
      ),
    );
  }
  return rules;
};
